// extracted by mini-css-extract-plugin
export default {"btn":"SliderArrow_btn__Oelp0","right":"SliderArrow_right__4C54R","left":"SliderArrow_left__ZM+6H"};